// TO-DO: in the future, this should come from the server
// or at least from some "game-aware" configuration file
export const vipDescriptions = ['', 'Amethyst', 'Topaz', 'Emerald', 'Opal', 'Beryl'];
